import React , {Component} from 'react'
import Home from './HomeComponent'
import LoginPage from './Pages/LoginPage'
import authStore from '../store/AuthStore';
import dispatcher from '../dispatcher/dispatcher';
// import { Spin, Icon } from 'antd';
import { connect } from 'react-redux';
import ChooseEntity from './Pages/ChooseEntity';

class MainComponent extends Component
{
    state = {
        authStore : authStore.initialState
    }

    componentWillMount () {
        authStore.on('update',()=>{
            this.setState({authStore:authStore.initialState})
        })
        dispatcher.dispatch({type:"AUTO_CHECK_STATE"})
    }

    render(){
        if(this.props.entity.entity && this.props.entity.server){
        const {auth} = this.props
        return this.props.auth ?  <Home token={auth.token}/> : <LoginPage/> 
            // <div style = {{display:'flex',width:'100vw',justifyContent:'center',height:'100vh',alignItems:'center'}}><Spin indicator = {<Icon type = "loading" />}  spinning tip="Loading..." size="large" delay={0} /></div>
        } else {
            return <ChooseEntity/>
        }
    }
}



export default connect(state=>({entity : state.entity , auth:state.auth.authData}),null)(MainComponent)


 